function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

var removeSpecials = function removeSpecials(key) {
  return typeof key === 'string' ? key.replace(/[^\w\s]/gi, '') : key;
};

function getClassName(property, key, breakpointKey) {
  var className = "" + [breakpointKey, property, removeSpecials(key)].filter(function (t) {
    return t;
  }).join('-');
  return "ts-" + className;
}

var getMediaQuery = function getMediaQuery(size) {
  return "@media screen and (min-width: " + size + ")";
};
function generateClassNamesFromArray(_ref) {
  var property = _ref.property,
      values = _ref.values,
      breakpoints = _ref.breakpoints;
  var styles = "";

  for (var _iterator = _createForOfIteratorHelperLoose(values), _step; !(_step = _iterator()).done;) {
    var _value = _step.value;

    var _className = getClassName(property, _value);

    styles += "\n    ." + _className + " { " + property + ": " + _value + "; }";
  }

  for (var breakpointKey in breakpoints) {
    var query = getMediaQuery(breakpoints[breakpointKey]);
    var breakpointStyles = "\n    " + query + " {";

    for (var _iterator2 = _createForOfIteratorHelperLoose(values), _step2; !(_step2 = _iterator2()).done;) {
      var value = _step2.value;
      var className = getClassName(property, value, breakpointKey);
      breakpointStyles += "\n        ." + className + " { " + property + ": " + value + "; }";
    }

    breakpointStyles += "\n    }";
    styles += breakpointStyles;
  }

  return styles;
}
function generateClassNamesFromObject(_ref2) {
  var property = _ref2.property,
      values = _ref2.values,
      breakpoints = _ref2.breakpoints;
  var styles = "";

  for (var key in values) {
    var className = getClassName(property, key);
    styles += "\n    ." + className + " { " + property + ": " + values[key] + "; }";
  }

  for (var breakpointKey in breakpoints) {
    var query = getMediaQuery(breakpoints[breakpointKey]);
    var breakpointStyles = "\n    " + query + " {";

    for (var _key in values) {
      var _className2 = getClassName(property, _key, breakpointKey);

      breakpointStyles += "\n        ." + _className2 + " { " + property + ": " + values[_key] + "; }";
    }

    breakpointStyles += "\n    }";
    styles += breakpointStyles;
  }

  return styles;
}
function generateSpaceProperty(_ref3) {
  var prefix = _ref3.prefix,
      properties = _ref3.properties,
      values = _ref3.values,
      breakpoints = _ref3.breakpoints;
  var styles = "";
  var valuesWithAuto = ['mt', 'mr', 'mb', 'ml', 'mx', 'my', 'm'].includes(prefix) ? _extends({}, values, {
    auto: 'auto'
  }) : values;

  for (var key in valuesWithAuto) {
    var className = getClassName(prefix, key);

    for (var _iterator3 = _createForOfIteratorHelperLoose(properties), _step3; !(_step3 = _iterator3()).done;) {
      var property = _step3.value;
      styles += "\n      ." + className + " { " + property + ": " + valuesWithAuto[key] + ";}";
    }
  }

  for (var breakpointKey in breakpoints) {
    var query = getMediaQuery(breakpoints[breakpointKey]);
    var breakpointStyles = "\n    " + query + " {";

    for (var _key2 in valuesWithAuto) {
      var _className3 = getClassName(prefix, _key2, breakpointKey);

      for (var _iterator4 = _createForOfIteratorHelperLoose(properties), _step4; !(_step4 = _iterator4()).done;) {
        var _property = _step4.value;
        breakpointStyles += "\n        ." + _className3 + " { " + _property + ": " + valuesWithAuto[_key2] + ";}";
      }
    }

    breakpointStyles += "\n    }";
    styles += breakpointStyles;
  }

  return styles;
}

var breakpoints = null;
function parseClassNames(property, prop, theme) {
  if (typeof prop === 'string') {
    return getClassName(property, prop);
  } else {
    var classnames = [];

    if (!breakpoints) {
      breakpoints = Object.keys(theme.breakpoints);
    }

    for (var breakpointKey in prop) {
      if (breakpointKey === '_') {
        classnames.push(getClassName(property, prop[breakpointKey]));
      } else if (breakpoints.includes(breakpointKey)) {
        classnames.push(getClassName(property, prop[breakpointKey], breakpointKey));
      } else {
        if (process.env.NODE_ENV === 'development') {
          console.warn("You've use '" + breakpointKey + "' as a breakpoint key but it's not defined in your theme. Classname mapping is ignored for this value");
        }
      }
    }

    return classnames.join(' ');
  }
}

var textAlign = ['left', 'center', 'right'];
var generate = function generate(theme) {
  var styles = "\n    " + generateClassNamesFromObject({
    property: 'color',
    values: theme.colors,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'font-weight',
    values: theme.fontWeights,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'font-family',
    values: theme.fontFamilies,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'font-size',
    values: theme.fontSizes,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'color',
    values: theme.colors,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromArray({
    property: 'text-align',
    values: textAlign,
    breakpoints: theme.breakpoints
  }) + "\n  ";
  return styles;
};
function parse(props, theme) {
  var classNames = '';

  if (props.fontWeight) {
    classNames += parseClassNames('font-weight', props.fontWeight, theme) + ' ';
  }

  if (props.fontFamily) {
    classNames += parseClassNames('font-family', props.fontFamily, theme) + ' ';
  }

  if (props.fontSize) {
    classNames += parseClassNames('font-size', props.fontSize, theme) + ' ';
  }

  if (props.textAlign) {
    classNames += parseClassNames('text-align', props.textAlign, theme) + ' ';
  }

  if (props.color) {
    classNames += parseClassNames('color', props.color, theme) + ' ';
  }

  return classNames.trimRight();
}

var generate$1 = function generate(theme) {
  return generateClassNamesFromObject({
    property: 'background-color',
    values: theme.colors,
    breakpoints: theme.breakpoints
  });
};
function parse$1(props, theme) {
  if (props.bg) {
    return parseClassNames('background-color', props.bg, theme);
  }

  return '';
}

var alignItems = ['flex-start', 'center', 'flex-end'];
var justifyContent = ['flex-start', 'center', 'flex-end', 'space-around', 'space-between'];
var wrap = ['wrap', 'wrap-reverse'];
var generate$2 = function generate(theme) {
  var styles = "\n    " + generateClassNamesFromArray({
    property: 'align-items',
    values: alignItems,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromArray({
    property: 'justify-content',
    values: justifyContent,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromArray({
    property: 'flex-wrap',
    values: wrap,
    breakpoints: theme.breakpoints
  }) + "\n  ";
  return styles;
};
function parse$2(props, theme) {
  var classNames = '';

  if (props.alignItems) {
    classNames += parseClassNames('align-items', props.alignItems, theme) + ' ';
  }

  if (props.justifyContent) {
    classNames += parseClassNames('justify-content', props.justifyContent, theme) + ' ';
  }

  if (props.flexWrap) {
    classNames += parseClassNames('flex-wrap', props.flexWrap, theme) + ' ';
  }

  return classNames.trimRight();
}

var display = ['block', 'flex', 'grid', 'initial', 'inline', 'inline-block', 'none'];
var sizesHorizontal = {
  '100': '100%',
  screen: '100vw',
  auto: 'auto'
};
var sizesVertical = {
  '100': '100%',
  screen: '100vh',
  auto: 'auto'
};
var generate$3 = function generate(theme) {
  var styles = "\n    " + generateClassNamesFromObject({
    property: 'width',
    values: sizesHorizontal,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'min-width',
    values: sizesHorizontal,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'height',
    values: sizesVertical,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromObject({
    property: 'min-height',
    values: sizesVertical,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateClassNamesFromArray({
    property: 'display',
    values: display,
    breakpoints: theme.breakpoints
  }) + "\n  ";
  return styles;
};
function parse$3(props, theme) {
  var classNames = '';

  if (props.display) {
    classNames += parseClassNames('display', props.display, theme) + ' ';
  }

  if (props.width) {
    classNames += parseClassNames('width', props.width, theme) + ' ';
  }

  if (props.minWidth) {
    classNames += parseClassNames('min-width', props.minWidth, theme) + ' ';
  }

  if (props.height) {
    classNames += parseClassNames('height', props.height, theme) + ' ';
  }

  if (props.minHeight) {
    classNames += parseClassNames('min-height', props.minHeight, theme) + ' ';
  }

  return classNames.trimRight();
}

var position = ['relative', 'absolute', 'fixed'];
var generate$4 = function generate(theme) {
  return generateClassNamesFromArray({
    property: 'position',
    values: position,
    breakpoints: theme.breakpoints
  });
};
function parse$4(props, theme) {
  if (props.position) {
    return parseClassNames('position', props.position, theme);
  }

  return '';
}

var generate$5 = function generate(theme) {
  var styles = "\n      " + generateSpaceProperty({
    prefix: 'mt',
    properties: ['margin-top'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'mr',
    properties: ['margin-right'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'mb',
    properties: ['margin-bottom'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'ml',
    properties: ['margin-left'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'mx',
    properties: ['margin-left', 'margin-right'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'my',
    properties: ['margin-top', 'margin-bottom'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'm',
    properties: ['margin'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'pt',
    properties: ['padding-top'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'pr',
    properties: ['padding-right'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'pb',
    properties: ['padding-bottom'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'pl',
    properties: ['padding-left'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'px',
    properties: ['padding-left', 'padding-right'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'py',
    properties: ['padding-top', 'padding-bottom'],
    values: theme.space,
    breakpoints: theme.breakpoints
  }) + "\n    " + generateSpaceProperty({
    prefix: 'p',
    properties: ['padding'],
    values: theme.space,
    breakpoints: theme.breakpoints
  });
  return styles;
};
var keys = ['mt', 'mr', 'mb', 'ml', 'mx', 'my', 'm', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'p'];
function parse$5(props, theme) {
  var classNames = '';

  for (var _iterator = _createForOfIteratorHelperLoose(keys), _step; !(_step = _iterator()).done;) {
    var key = _step.value;

    if (props[key]) {
      classNames += parseClassNames(key, props[key], theme) + ' ';
    }
  }

  return classNames.trimRight();
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var props = ['bg', 'alignItems', 'justifyContent', 'flexWrap', 'gridTemplateColumns', 'gridColumnGap', 'gridColumnStart', 'gridColumnEnd', 'gridColumn', 'display', 'width', 'minWidth', 'height', 'minHeight', 'position', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'm', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'p', 'fontWeight', 'fontFamily', 'fontSize', 'textAlign', 'color'];
var regex = /*#__PURE__*/new RegExp("^(" + /*#__PURE__*/props.join('|') + ")$");
var shouldForwardProp = /*#__PURE__*/memoize(function (prop) {
  return !regex.test(prop);
});
var filterProps = function filterProps(props) {
  if (typeof props === 'object') {
    var filtered = {};

    for (var key in props) {
      if (props.hasOwnProperty(key) && shouldForwardProp(key)) {
        filtered[key] = props[key];
      }
    }

    return filtered;
  }

  return props;
};

var generator = function generator(theme) {
  if (!theme) {
    throw new Error('No theme was passed to generator');
  }

  var utilities = "\n    " + generate$5(theme) + "\n    " + generate(theme) + "\n    " + generate$1(theme) + "\n    " + generate$2(theme) + "\n    " + generate$3(theme) + "\n    " + generate$4(theme) + "\n  ";
  return utilities;
};

function createParser(theme) {
  function parse$6(props, additionalClassName) {
    return [parse$5(props, theme), parse(props, theme), parse$1(props, theme), parse$2(props, theme), parse$3(props, theme), parse$4(props, theme), additionalClassName].filter(function (s) {
      return s && s.length;
    }).join(' ').trim();
  }

  return parse$6;
}

function createThemeSystem(theme) {
  var utilities = generator(theme);
  var parse = createParser(theme);
  var parseAll = createParser(theme);
  return {
    utilities: utilities,
    parse: parse,
    parseAll: parseAll
  };
}

export { createThemeSystem, filterProps, generator };
//# sourceMappingURL=theme-system.esm.js.map
